import { all, takeLatest, put, call } from 'redux-saga/effects';
import * as types from './types';
import * as authActions from './actions';

import { post } from 'library/endpoints';
import { toggleMessage, resetEnv } from 'modules/ui/actions';

import i18next from 'i18next';
import { push } from 'connected-react-router';


/**
 * login
 */
export function* login({ payload: { email, password }}) {
  yield put(authActions.loginProcess());

  try {
    yield put(resetEnv());
    const response = yield call(post, '/frontend/auth/login', { email, password });
    
    yield put(authActions.loginSuccess(response.data));
    yield put(push('/home'));

  } catch (err) {
    yield put(authActions.loginError());
    yield put(toggleMessage({
      display: true,
      content: i18next.t('Auth.login.error', 'Erreur lors de la tentative de connexion, vérifiez vos identifiants'),
      type: 'error'
    }));
  }
}

/**
 * login
 */
export function* autologin({ payload: { autologintoken }}) {
  yield put(authActions.loginProcess());

  try {
    yield put(resetEnv());
    const response = yield call(post, '/frontend/auth/autologin', { autologintoken });
    
    yield put(authActions.loginSuccess(response.data));
    yield put(push('/home'));

  } catch (err) {
    yield put(authActions.loginError());
    yield put(toggleMessage({
      display: true,
      content: i18next.t('Auth.login.error', 'Erreur lors de la tentative de connexion, vérifiez vos identifiants'),
      type: 'error'
    }));
  }
}


/**
 * rootSaga
 */
export default function* rootSaga() {
  yield all([
    takeLatest(types.LOGIN, login),
    takeLatest(types.AUTOLOGIN, autologin)
  ]);
}
